import Box from 'grommet/components/Box';
import CheckBox from 'grommet/components/CheckBox';
import React from 'react';
import Button from 'grommet/components/Button';
import Tiles from 'grommet/components/Tiles';
import Tile from 'grommet/components/Tile';
import Anchor from 'grommet/components/Anchor';
import LineChartIcon from 'grommet/components/icons/base/LineChart';

const internaltext=[{
    position: "54%",
    size: 12,
    bold: true,
    text: 'Internal Title',
    color: '#58585b'
},{
    position: "42%",
    size: 32,
    bold: false,
    text: '1234',
    color: '#58585b'
}]

const color = ["rgb(83,194,205)","rgb(157,87,4)","rgb(91,100,114)","rgb(86,130,216)","rgb(188,98,218)","rgb(196,175,84)","rgb(60,66,173)","rgb(226,160,160)","rgb(175,153,239)"]

class DonutOptions extends React.Component {
    constructor() {
        super();
        this._onClickSlice = this._onClickSlice.bind(this);
        //this._onChange = this._onChange.bind(this)
        this.state = { 
            legends: true,
        };
        this._onClick = this._onClick.bind(this);
    }
    _onClick(output) {

        this.props.onSubmit(output)
    }
    
    _onClickSlice(event) {
        console.log(event);
    }
    _onChange(event) {
        let {legends} = this.state
        switch(event) {
            case "legends":
                this.setState({ legends: !legends })
                break;
        }
    }
    render() {
        //let { inttext, legendposition, labels, legends, exprt, piecolor } = this.state
        const {legends} = this.state
        const output = {legends};
        return (
            <div>
            <Box>	  
                    <Tiles>
                        <Tiles fill={true} flush={true} justify="center" responsive={true} selectable={true} size={"small"} onSelect={this._onSelect}>
                            <Tile pad={{"horizontal": "medium"}} colorIndex="light-1" key={0} style={{maxWidth: "400px"}}>
                                <Box pad="small" colorIndex="light">
                                    <h4>Bar Chart</h4>
                                    <Box align="center">
                                        <Anchor>
                                            <LineChartIcon size="small" colorIndex="grey-1"/>
                                        </Anchor>
                                    </Box>
                                </Box>	
                            </Tile>
                        </Tiles>
                    </Tiles>
                </Box>
                <Box direction='row'
                    justify='center'
                    align='center'
                    wrap={true}
                    reverse={false}
                    margin='none'
                    >
                    
                    <Box direction='row'
                        
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'
                        > 
                        <CheckBox 
                        name='legends'
                        id='legends'
                        label='Legends'
                        toggle={true}
                        disabled={false}
                        reverse={true}
                        onChange={this._onChange.bind(this, 'legends')}
                        />
                    </Box>
            </Box>
            <Button label='Submit'
                type='submit'
                primary={true}
                onClick={this._onClick.bind(this, output)} />
            </div>
        );
    }
}

export default DonutOptions;



// WEBPACK FOOTER //
// ./src/samples/options/pie.js